import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router'
import Landing from './pages/Landing'
import GetStarted from './pages/GetStarted'
import ProjectList from './pages/ProjectList'
import View from './pages/View'
import MeshGrid from './pages/MeshGrid'
import { DocsIndex, DocsArticle } from './pages/Docs'
import Pricing from './pages/Pricing'
import BillingSuccess from './pages/BillingSuccess'
import BillingCancel from './pages/BillingCancel'
import DeviceApprove from './pages/DeviceApprove'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import Contact from './pages/Contact'
import McpServer from './pages/McpServer'
import Agents from './pages/Agents'
import Showcase from './pages/Showcase'
import { RecipesIndex, RecipeArticle } from './pages/Recipes'
import NotFound from './pages/NotFound'
import Layout from './components/Layout'
import { RouteErrorBoundary } from './components/ErrorBoundary'
import './index.css'
// SEM-68: dropdown popover styling for action-column select cells.
import '@glideapps/glide-data-grid-cells/dist/index.css'

const router = createBrowserRouter([
  // Pages that use the prototype shell (TopNav + MeshLattice + Footer)
  {
    element: <Layout />,
    errorElement: <RouteErrorBoundary />,
    children: [
      { path: '/',                  element: <Landing /> },
      { path: '/get-started',       element: <GetStarted /> },
      { path: '/workspace',         element: <ProjectList /> },
      { path: '/docs',              element: <DocsIndex /> },
      { path: '/docs/:articleId',   element: <DocsArticle /> },
      { path: '/pricing',           element: <Pricing /> },
      { path: '/billing/success',   element: <BillingSuccess /> },
      { path: '/billing/cancel',    element: <BillingCancel /> },
      { path: '/device',            element: <DeviceApprove /> },
      { path: '/privacy',           element: <Privacy /> },
      { path: '/terms',             element: <Terms /> },
      { path: '/contact',            element: <Contact /> },
      { path: '/mcp',               element: <McpServer /> },
      { path: '/agents',            element: <Agents /> },
      { path: '/showcase',          element: <Showcase /> },
      { path: '/recipes',           element: <RecipesIndex /> },
      { path: '/recipes/:recipeId', element: <RecipeArticle /> },
      { path: '*',                  element: <NotFound /> },
    ],
  },
  // Pages that manage their own chrome (full-bleed grid views)
  { path: '/view/:id',          element: <View />,    errorElement: <RouteErrorBoundary /> },
  // Flat handle-rooted grid URL — visibility is resolved server-side from the
  // grid metadata, not encoded in the path. Listed last so explicit Layout
  // routes (/, /pricing, /docs, /workspace, /billing/*, /device, /docs/:id) win.
  { path: '/:handle/:slug',     element: <MeshGrid />, errorElement: <RouteErrorBoundary /> },
])

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
